import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  image: string;
  title: string;
  description: string;
  delay?: number;
}
export function BonusCard({
  image,
  title,
  description,
  delay = 0
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white rounded-2xl overflow-hidden shadow-xl border-2 border-purple-100 flex flex-col h-full transform hover:-translate-y-1 transition-transform duration-300" data-id="element-1">
      <div className="relative" data-id="element-2">
        <img src={image} alt={title} className="w-full h-auto object-cover" data-id="element-3" />
        <div className="absolute top-4 right-4 bg-yellow-400 text-yellow-900 font-bold px-3 py-1 rounded-full text-sm shadow-md animate-pulse" data-id="element-4">
          GRATIS HOY
        </div>
      </div>
      <div className="p-6 flex flex-col flex-grow" data-id="element-5">
        <h3 className="text-xl font-bold text-purple-900 mb-2" data-id="element-6">{title}</h3>
        <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-7">{description}</p>

        <div className="bg-green-50 border-l-4 border-green-400 p-3 rounded-r-lg mb-4" data-id="element-8">
          <p className="text-green-800 text-xs font-medium" data-id="element-9">
            {title.includes('Diseño Gráfico') && '✓ Evita pagar diseñadores externos y crea tus propios diseños profesionales'}
            {title.includes('Instalación') && '✓ Elimina la frustración de no saber qué programas usar para empezar'}
            {title.includes('Personajes') && '✓ Ahorra horas de búsqueda y diseño con recursos listos para usar'}
          </p>
        </div>

        <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-10">
          <p className="text-xs text-gray-400 line-through mb-1" data-id="element-11">
            Precio normal: $10.000
          </p>
          <p className="text-green-600 font-bold" data-id="element-12">¡Gratis con tu compra!</p>
        </div>
      </div>
    </motion.div>;
}